import BetaSubheader from '@/ui//BetaSubheader';
import Header from './components/header/Header';
import { Outlet } from 'react-router-dom';
import { getLastValidDate } from '@/api/user';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { AppSidebar } from '@/components/app-sidebar';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';

const MainFrame = () => {
  const [dataVlidation, setDataValidation] = useState<string | undefined>(undefined);

  const checkDataValidation = async () => {
    const lastVisit = localStorage.getItem('lastVistit');
    if (lastVisit && !moment(lastVisit).isSame(moment(), 'date')) {
      const res = await getLastValidDate();
      if (!res.data.is_latest) {
        setDataValidation(res.data.latest_valid_date);
      } else {
        setDataValidation(undefined);
        localStorage.setItem('lastVistit', moment().toISOString());
      }
    } else {
      localStorage.setItem('lastVistit', moment().toISOString());
    }
  };

  useEffect(() => {
    checkDataValidation();
  }, []);

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <div>
          <BetaSubheader open={dataVlidation} onClose={() => setDataValidation(undefined)} />
        </div>
        <div className={cn('relative')}>
          <Header />
        </div>
        <div className="px-8 py-4">
          <div className="mt-12 md:mt-16">{Outlet ? <Outlet /> : null}</div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default MainFrame;
